import { useMutation, useQuery } from "@apollo/client/react";import { Grid } from "@mui/material";
import { useEffect, useMemo, useState, useCallback } from "react";

import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { useVisita } from "../../../../../../context/VisitaContext";
import { useStepSave } from "../../../../hooks/useStepSave";
import { filterVisitaData, getInputNames } from "../../../../utils/formDataHelper";
import CardBox from "../../CardBox/CardBox";
import SAVE_VISITA_EVOLUCION_PACIENTE, { adaptSaveVisitaEvolucionPaciente } from "../../../../../../data/graphQL/mutations/Visitas/saveVisitaEvolucionPaciente";
import { validateStepFields } from "../../../../utils/visitaStepValidation";
import { EstudiosComplementarios } from "../../EstudiosComplementarios";
import { handleChangeSolvedFileVisita } from "../../../../utils/handleChangeImageVisita";
import { tipoArchivoVisita } from "../../../../constants/TipoArchivosVisita";
import { useDeleteArchivoVisita } from "../../../../hooks/useDeleteArchivoVisita";

export default function EvolucionEspecialista({ esUrgencia, readOnly, onSaveRef, onExposeFormatted }) {
  const [formData, setFormData] = useState({});
  const { visita, setVisita, saveArchivoVisita } = useVisita();
  const [childrenAction, setChildrenAction] = useState(null);
  const { deleteArchivo } = useDeleteArchivoVisita();

  const [save] = useMutation(SAVE_VISITA_EVOLUCION_PACIENTE);

  const formattedGroups = useMemo(() => {
    return inputsGroups.map((group) => ({
      ...group,
      inputs: group.inputs.
      map((input) => {
        const newInput = { ...input };

        if (readOnly) newInput.disabled = true;

        return newInput;
      })
    }));
  }, [readOnly, formData]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeFile = useCallback((name, file) => {
    handleChangeSolvedFileVisita({
      saveArchivoVisita,
      name,
      fileValue: file,
      idVisita: visita.idVisita,
      handleChange,
      archivos: formData?.estudioAdjunto,
      idTipoArchivo: tipoArchivoVisita.ESTUDIO_COMPLEMENTARIO
    });
  }, [visita.idVisita, saveArchivoVisita, formData?.estudioAdjunto]);

  const onDeleteImage = useCallback((name, idArchivo, archivos) => {
    deleteArchivo({
      idArchivo: idArchivo,
      name: name,
      archivos: archivos,
      handleChange
    });
  }, [visita.idVisita]);

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedGroups, formData });

    const { data } = await save({ variables: adaptSaveVisitaEvolucionPaciente(formData) });
    const idVisita = data?.saveVisitaEvolucionPaciente?.idVisita;
    if (!idVisita) throw new Error("Error al guardar");
    setVisita((prev) => ({ ...prev, ...formData }));
  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: "evolucionPacienteEspecilista",
      stepName: "Evolución del paciente",
      formattedGroups
    });
  }, [onExposeFormatted, formattedGroups]);

  return (
    <CardBox>

            {formattedGroups.
      map((group) =>
      <Grid className='step-form-section-container' container spacing={2}>
                        {
        group.groupName === 'Estudios complementarios' &&
        <label className={`step-form-section-title ${childrenAction ? 'with-children-action' : ''}`}>
                                {group.groupName} {Boolean(childrenAction) && childrenAction}
                            </label>
        }
                        {group.inputs.filter((input) => !input.hidden).
        map((input) =>
        <Grid size={{ xs: 12 }} key={input.name}>
                                    {'estudioAdjunto' !== input.name && <RenderInputByTypeMobile
            key={`${group.groupName}-${input.name}`}
            input={input}
            label={input.displayName}
            value={formData[input.name]}
            handleChange={handleChange}
            row={input.type === "multiple_boolean"} />
          }
                                    {input.name === 'estudioAdjunto' && <EstudiosComplementarios
            key={`${group.groupName}-${input.name}`}
            name={input.name}
            handleChange={handleChangeFile}
            setChildrenAction={setChildrenAction}
            prevAdjuntos={formData[input.name]}
            onDeleteAdjunto={(name, idArchivo, archivos) => onDeleteImage(name, idArchivo, archivos)}
            readOnly={readOnly} />
          }
                                </Grid>
        )}
                    </Grid>
      )}
        </CardBox>);

}

const inputsGroups = [
{
  groupName: 'Estudios complementarios',
  inputs: [
  {
    displayName: 'Estudio complementario',
    name: 'estudioAdjunto'
  },
  {
    displayName: 'Evolución',
    name: 'evolucion',
    type: 'long_string',
    longStringRows: 9,
    maxLength: 4000
  }]

}];